import { render, staticRenderFns } from "./ContratosVigentes.vue?vue&type=template&id=181a73f1"
import script from "./ContratosVigentes.vue?vue&type=script&lang=js"
export * from "./ContratosVigentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports